import { StatCard } from "@/components/ui/stat-card";
import type { PortfolioStats } from "@/lib/dashboard-stats";

/**
 * Four plain tiles. Deliberately non-interactive: docs/design-guidelines.md
 * resolves the plain stat tile to StatCard and rules out MetricCard, which is
 * the clickable variant but requires a completion percentage these counts
 * don't have. Navigation lives in ReadinessPanel's rows instead.
 */
export function PortfolioStrip({ stats }: { stats: PortfolioStats }) {
  return (
    <div className="grid grid-cols-2 gap-4 md:grid-cols-4">
      <StatCard label="Assets assessed" value={stats.assetCount} />
      <StatCard label="Countries" value={stats.countryCount} />
      {/* "Very high", not "Critical" — LEVEL_LABELS[4] is the binding wording. */}
      <StatCard label="Very high importance" value={stats.veryHighImportanceCount} />
      {/* "Stages with assets", not "covered" — §2 shows a different fraction
          over the same denominator, and two same-shaped fractions on one
          screen invite misreading. */}
      <StatCard label="Stages with assets" value={`${stats.stagesCovered} of ${stats.stagesTotal}`} />
    </div>
  );
}
